export type ScoreBucket = 'low' | 'mid' | 'high';

export const getScoreBucket = (score: number): ScoreBucket => {
  if (score < 2) {
    return 'low';
  }

  if (score < 4) {
    return 'mid';
  }

  return 'high';
};
